import { Session as CoreSession, Storage as CoreStorage, Config as CoreConfig } from '@atabix/core';
import environments from '@/environments';

class Storage extends CoreStorage {}
Storage.setPrefix('com.atabix_vue_maison_');

class Session extends CoreSession {}
Session.setPrefix('com.atabix_vue_maison_');

class Config extends CoreConfig {}
Config.setStorage(Storage);
Config.setSession(Session);
Config.setEnvironments(environments);

export { Storage, Session, Config };

export type ConfigValue = boolean | string | number | undefined;
